import { lazy } from "react";
import { Navigate } from "react-router-dom";
import MainLayout from "../layout/mainLayout";

const Dashboard = lazy(() => import("../pages/Dashboard/dashboard"));
const Customers = lazy(() => import("../pages/Customer/customers"));
const Tasks = lazy(() => import("../pages/Tasks/tasks"));
const TaskView = lazy(() => import("../pages/Tasks/taskView"));

const Agents = lazy(() => import("../pages/Agents/agents"));
const AddAgent = lazy(() => import("../pages/Agents/addAgent"));
const AgentView = lazy(() => import("../pages/Agents/agentView"));


const AddCustomer = lazy(() => import("../pages/Customer/addCustomer"));
const Teams = lazy(() => import("../pages/Teams/teams"));
const AddTeam = lazy(() => import("../pages/Teams/addTeam"));

const GeoFence = lazy(() => import("../pages/GeoFence/geoFence"));
const AddGeoFence = lazy(() => import("../pages/GeoFence/addGeoFence.jsx"));
const GeofenceMapView = lazy(() => import("../pages/GeoFence/geoFenceMapView.jsx"));

const Profile = lazy(() => import("../pages/Profile/profile"));

const AutoAllocation = lazy(() => import("../pages/AutoAllocation/autoAllocation"));
const Configuration = lazy(() => import("../pages/Configuration/configuration"));
const Overview = lazy(() => import("../pages/Analytics/overview"));
const EyeView = lazy(() => import("../pages/Analytics/birdsEyeView"));
const Reports = lazy(() => import("../pages/Analytics/reports"));
const Notifications = lazy(() => import("../pages/Notifications/notifications"));

export const privateRoutes = [
  {
    path: "/home",
    element: <MainLayout />,
    children: [
      { index: true, element: <Navigate to="dashboard" replace /> }, // default redirect
      { path: "dashboard", element: <Dashboard /> },
      { path: "customers", element: <Customers /> },
      { path: "tasks", element: <Tasks /> },
      { path: "tasks-view", element: <TaskView /> },

      { path: "agents", element: <Agents /> },
      { path: "add-agents", element: <AddAgent /> },
      { path: "agents-view", element: <AgentView /> },
      { path: "add-customer", element: <AddCustomer /> },
      { path: "teams", element: <Teams /> },
      { path: "add-teams", element: <AddTeam /> },
      { path: "profile", element: <Profile /> },
      { path: "geo-fence", element: <GeoFence /> },
      { path: "add-geo-fence", element: <AddGeoFence /> },
      { path: "geo-fence-map-view", element: <GeofenceMapView /> },
      { path: "auto-allocation", element: <AutoAllocation /> },
      { path: "system-configuration", element: <Configuration /> },
      { path: "analytics-overview", element: <Overview /> },
      { path: "birds-eye-view", element: <EyeView /> },
      { path: "analytics-reports", element: <Reports /> },
      { path: "notifications", element: <Notifications /> },
    ],
  },
];  